import React from 'react';
import './index.scss'

const RichTextFloor = props => {
    const {data} = props;
    const {content_, margin_, padding_, background_, min_height_} = data;
    const style = {
        marginBottom: margin_ + 'px',
        paddingTop: padding_.top_ + 'px',
        paddingLeft: padding_.left_ + 'px',
        paddingRight: padding_.right_ + 'px',
        paddingBottom: padding_.bottom_ + 'px',
        minHeight: min_height_ + 'px',
        backgroundColor: background_.color_,
        backgroundPositionX: background_.horizontal_,
        backgroundPositionY: background_.vertical_,
        backgroundRepeat: background_.repeat_ === 'padding' ? 'no-repeat' : background_.repeat_,
        backgroundSize: background_.repeat_ === 'padding' ? '100% 100%' : '',
    };
    if (background_.img_) {
        style['backgroundImage'] = 'url(' + background_.img_ + ')'
    }
    return (
        <div style={style}>
            <div dangerouslySetInnerHTML={{__html: content_}}/>
        </div>
    )
};
export default RichTextFloor